module.exports = __webpack_public_path__ + "static/media/view-blockchain.f1d176a3.svg";